/* --- STATE --- */

import { biType } from '../../../../locales/types';

export interface WorkListState {
  searhList: WorkListDataState[] | null,
  contractStatus: WorkListDataState | null,
  selectedPreviewSection: biType | null;
  username: string;
  userEmail: string;
  dept: string;
  accessRight: AccessRightState;
  errorDialog: boolean;
  errorWordings: string;
  leftMenuOpen: boolean;
  historyDate: string;
  lastFilter: any;
  loading: boolean;
}

export interface WorkListDataState {
  contractNumber: string,
  biCreateDate: string,
  customerCode: string,
  customerName: string,
  contractType: string,
  contractStartDate: string,
  biSubmittedDate: string,
  recurringStatus: string,
  novatedDate: string,
  oneOffStatus: string,
  depositStatus: string,
  changeBillDateStatus: string,
  contractInfoStatus: string,
  terminationStatus: string,
  biStatus: string,
  remark: string,
  createdAt: string,
  updatedAt: string,
  statusReasons: Record<string, string>;
}

export const initialWorkListDataState = {
  contractNumber: '',
  biCreateDate: '',
  customerCode: '',
  customerName: '',
  contractType: '',
  contractStartDate: '',
  biSubmittedDate: '',
  recurringStatus: '',
  oneOffStatus: '',
  depositStatus: '',
  changeBillDateStatus: '',
  terminationStatus: '',
  createdAt: '',
  updatedAt: '',
};

export interface AccessRightState {
  edit: boolean,
  view: boolean,
}

export const initialAccessRightState = {
  edit: false,
  view: false,
}

export interface worklistFilter {
  customerCode: string,
  contractNumber: string,
  contractType: string[],
}

export const initialWorklistFilter = {
  customerCode: '',
  contractNumber: '',
  contractType: ['New', 'Renew'],
}